if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.book-now').on('click', function(e) {
        e.preventDefault();
        var destinationUrl = $(this).attr('href');  
        ga(function(tracker) {
               var linker = new window.gaplugins.Linker(tracker);
             var output = linker.decorate(destinationUrl, true);
             ga('send', 'event', 'reservations', 'click', 'book now');
             window.open(output, '_blank');
             }); 
    }); 
    
    
    $('.book-now-main').on('click', function(e) {
        e.preventDefault();
        var destinationUrl = $(this).attr('href');  
        ga(function(tracker) {
                var linker = new window.gaplugins.Linker(tracker);
                var output = linker.decorate(destinationUrl, true);
                ga('send', 'event', 'reservations', 'click', 'book now');
                window.open(output, '_blank');
            }); 
    }); 

        
    $('.sym-slides').slick({
        accessibility: true,
        dots: true,
    });


    $('.js-open-change-property').click(function(){
        if($('.js-dropdown-legends').hasClass('show')){
            $('.js-dropdown-legends').removeClass('show');
            $(this).removeClass('open');
        }else{
            $('.js-dropdown-legends').addClass('show');
            $(this).addClass('open');
        }
    })

    $('.tabs__text ul li').mouseover(function(){
        $('.tabs__text ul li').removeClass('active');
        var dataImg = $(this).data('src');
        var dataAlt = $(this).data('alt');
        setTimeout(function(){
            $('.js-image-change img').attr('src', dataImg);
            $('.js-image-change img').attr('alt', dataAlt);
        },100)
        $(this).addClass('active');
    });

    $('.intro-content__booking-benefits .title').prependTo('.intro-content__booking-benefits .sym-inline-list');

    if($('#default.accommodations').length > 0){
        $('.amenities.beige').appendTo('.intro-content.intro-image.accomodations');
    }

    if($('.slider-and-location').length > 0){
        $('.sliders-slider-left').slick({
            arrows: true,
            dots: true,
            autoplaySpeed: 7000,
            speed: 700,
            fade: true,
            asNavFor: '.sliders-slider-right'
        });
        $('.sliders-slider-right').slick({
            arrows: false,
            dots: false,
            speed: 700,
            fade: true
        });
    }

    $('.simple-quad-slider__slider').slick({
        arrows: true,
        autoplay: true,
        autoplaySpeed: 7000,
        speed: 700,
        fade: true,
        prevArrow: '<button type="button" class="slick-prev">prev</button>',
        nextArrow: '<button type="button" class="slick-next">next</button>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    arrows: false,
                    dots: true
                }
            }
        ]
    });

    $('.accommodations-shortcode__slider-images').slick({
        arrows: true,
        autoplay: false,
        autoplaySpeed: 7000,
        speed: 700,
        fade: true,
        prevArrow: '<button type="button" class="slick-prev">prev</button>',
        nextArrow: '<button type="button" class="slick-next">next</button>'
    });

    if($('.slider').length > 0){
        $('.slider-slider-left').slick({
            arrows: true,
            dots: true,
            autoplaySpeed: 7000,
            speed: 700,
            fade: true,
            asNavFor: '.slider-slider-right'
        });
        $('.slider-slider-right').slick({
            arrows: false,
            dots: false,
            speed: 700,
            fade: true
        });
    }
    



    const acc_btns = document.querySelectorAll('.accordion__button');
    const acc_items = document.querySelectorAll('.accordion__item');
    if(acc_btns){
        for(let i = 0; i < acc_btns.length; i++){
            acc_btns[i].addEventListener('click', function(){
                if(this.closest('.accordion__item').classList.contains('active')){
                    this.closest('.accordion__item').classList.remove('active');
                }else{
                    for(let a = 0; a < acc_items.length; a++){
                        acc_items[a].classList.remove('active');
                    }
                    this.closest('.accordion__item').classList.add('active');
                }
            })
        } 
    }

    if($('.accordion__filter').length > 0){
        $('.accordion__filter ul li').click(function(){
            const thisTag = $(this).attr('data-tag');
            if(thisTag != 'all'){
                $('.accordion__container .accordion__item').hide();
                $('.accordion__container .'+thisTag).fadeIn();
                $('.accordion__filter ul li').removeClass('active');
                $(this).addClass('active');
            }else{
                $('.accordion__container .accordion__item').fadeIn();
                $('.accordion__filter ul li').removeClass('active');
                $(this).addClass('active');
            }
        });
    }

    if(document.querySelector('.accordion__filter')){
        const filter_tab = document.querySelectorAll('.accordion__filter ul li'); filter_tab[filter_tab.length - 1].click();
    }

    $('.text-modules').addClass('animate-fade top');
    
    $('.form-module').addClass('animate-fade top');


    const acc_btnsChart = document.querySelectorAll('.accordion-capacity-chart__button');
    const acc_itemsChart = document.querySelectorAll('.accordion-capacity-chart__item');
    if(acc_btnsChart){
        for(let i = 0; i < acc_btnsChart.length; i++){
            acc_btnsChart[i].addEventListener('click', function(){
                if(this.closest('.accordion-capacity-chart__item').classList.contains('active')){
                    this.closest('.accordion-capacity-chart__item').classList.remove('active');
                }else{
                    for(let a = 0; a < acc_itemsChart.length; a++){
                        acc_itemsChart[a].classList.remove('active');
                    }
                    this.closest('.accordion-capacity-chart__item').classList.add('active');
                }
            })
        } 
    }

    //SUBNAVIGATION

	// Open active sub-nav on load
	$('.navigation ul.submenu li .active').closest('.inner').addClass('open')
	$('.navigation ul.submenu li .active').parents().parents('li').addClass('item-open');
	$('.navigation ul.submenu li .active').closest('.sub-sub-menu').slideDown(300, function () { }).addClass('menu-open');

	//Toggle open/close on tap
	$('.navigation li a').off('click').on('click', function (event) {
		if ($(this).parent().children(".sub-sub-menu").length > 0) {

			event.preventDefault();

			if ($(this).next().hasClass('menu-open')) {
				$(this).closest('.inner').removeClass('open');
				$('.navigation ul li').removeClass('item-open');
				$(this).parent().addClass('item-open');
				$(this).next().slideUp(300, function () {
					if ($('.navigation ul li a').hasClass('active')) {
						$(".item-open").get(0).scrollIntoView(false);
					}
				}).removeClass('menu-open');
			} else {
				$(this).closest('.inner').addClass('open');
				$('.navigation ul li').removeClass('item-open');
				$(this).parent().addClass('item-open');
				$('.sub-sub-menu.menu-open').slideUp(300).removeClass('menu-open');
				$(this).next().addClass('menu-open').slideDown(300, function () {
					if ($('.navigation ul li a').hasClass('active')) {
						$(".item-open").get(0).scrollIntoView(false);
					}
				});
			}
		}
	});


    $('#js-open-menu').click(function(){
        $('.navigation.overlay').addClass('show');
    })

    $('.js-close-menu-mobile').click(function(){
        $('.navigation.overlay').removeClass('show');
    })

    if($('.accordion__filter-mobile').length > 0){
        $('#filter-tabs-accordion').on('change', function () {
            const thisTag = $(this).val();
            if(thisTag != 'all'){
                $('.accordion__container .accordion__item').hide();
                $('.accordion__container .'+thisTag).fadeIn();
            }else{
                $('.accordion__container .accordion__item').fadeIn();
            }
        });
    }

	if ($('#filter-tabs-accordion').length > 0) {
		$('#filter-tabs-accordion').val('all').trigger('change');
	}

})();

var $loupe = $(".loupe"),
    loupeWidth = $loupe.width(),
    loupeHeight = $loupe.height();

$(document).on("mouseenter", ".image-zoom", function (e) {
    var $currImage = $(this),
        $img = $('<img/>')
        .attr('src', $('img', this).attr("src"))
        .css({ 'width': $currImage.width() * 2, 'height': $currImage.height() * 2 });

    $loupe.html($img).fadeIn(100);
    
    $(document).on("mousemove",moveHandler);
                   
    function moveHandler(e) {
        var imageOffset = $currImage.offset(),
            fx = imageOffset.left - loupeWidth / 2,
            fy = imageOffset.top - loupeHeight / 2,
            fh = imageOffset.top + $currImage.height() + loupeHeight / 2,
            fw = imageOffset.left + $currImage.width() + loupeWidth / 2;
        
        $loupe.css({
            'left': e.pageX - 75,
            'top': e.pageY - 75
        });

        var loupeOffset = $loupe.offset(),
            lx = loupeOffset.left,
            ly = loupeOffset.top,
            lw = lx + loupeWidth,
            lh = ly + loupeHeight,
            bigy = (ly - loupeHeight / 4 - fy) * 2,
            bigx = (lx - loupeWidth / 4 - fx) * 2;

        $img.css({ 'left': -bigx, 'top': -bigy });

        if (lx < fx || lh > fh || ly < fy || lw > fw) {
            $img.remove();
            $(document).off("mousemove",moveHandler);
            $loupe.fadeOut(100);
        }
    }
});
